
import { buildAssetUri } from '@/utils/mixins';
import Avatar from 'vue-avatar';
import {
  defaultCompanyPictureUri,
  defaultProfilePictureUri,
} from '~/utils/behavior/images';

export default {
  name: 'ProfileImg',
  components: {
    Avatar,
  },
  mixins: [buildAssetUri],
  props: {
    src: {
      default: null,
      type: String,
    },
    alt: {
      default: '',
      type: String,
    },
    profileType: {
      default: 'PersonalProfile',
      type: String,
    },
    displayName: {
      default: '',
      type: String,
    },
    size: {
      default: 40,
      type: Number,
    },
    hasBorders: {
      type: Boolean,
      default: false,
    },
    previewUri: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      defaultUri: defaultProfilePictureUri,
      defaultCompanyUri: defaultCompanyPictureUri,
    };
  },
};
